module.exports = __webpack_public_path__ + "static/media/question_icon.aa88e5e2.png";